import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import EmptyState from "@/components/base/EmptyState";
import { newsItems } from "@/mocks/content";

export default function NewsSidebar() {
  const latest = [...newsItems]
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 6);

  return (
    <section className="rounded-lg border border-background-300 bg-background-50 p-5">
      <SectionTitle
        title="最新动态"
        action={
          <Link
            to="/category/news"
            className="flex items-center gap-1 whitespace-nowrap text-xs text-primary-600 hover:text-primary-700"
          >
            全部
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        }
      />
      {latest.length === 0 ? (
        <EmptyState message="暂无最新内容，敬请期待" icon="ri-newspaper-line" />
      ) : (
        <ul className="flex max-h-[420px] flex-col gap-1 overflow-y-auto no-scrollbar">
          {latest.map((item) => (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
              >
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
                <span className="flex min-w-0 flex-1 flex-col">
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </span>
                  <span className="mt-1 text-xs text-foreground-400">{item.date}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}